import { useCallback, useEffect, useRef, useState } from 'react';
import { PcmStreamPlayer } from 'lib/pcm-stream-player';
export const useLiveInputAudioMonitor = ({ wsClient, transportOnline, selectedAudioSourceConnectionId, }) => {
    const [listening, setListening] = useState(false);
    const playerRef = useRef(null);
    const canListen = transportOnline && selectedAudioSourceConnectionId !== null;
    const stopListening = useCallback(() => {
        setListening(false);
        wsClient?.sendLiveInputAudioMonitor(false);
        playerRef.current?.stop();
    }, [wsClient]);
    useEffect(() => {
        playerRef.current = new PcmStreamPlayer();
        return () => {
            wsClient?.sendLiveInputAudioMonitor(false);
            playerRef.current?.dispose();
            playerRef.current = null;
        };
    }, [wsClient]);
    useEffect(() => {
        if (transportOnline) {
            return;
        }
        stopListening();
    }, [transportOnline, stopListening]);
    useEffect(() => {
        if (selectedAudioSourceConnectionId !== null || !listening) {
            return;
        }
        stopListening();
    }, [selectedAudioSourceConnectionId, listening, stopListening]);
    useEffect(() => {
        if (!listening || wsClient === null) {
            wsClient?.setLiveInputAudioHandler(null);
            return;
        }
        wsClient.setLiveInputAudioHandler((pcm) => {
            void playerRef.current?.resume();
            playerRef.current?.playChunk(pcm);
        });
        return () => {
            wsClient.setLiveInputAudioHandler(null);
        };
    }, [listening, wsClient]);
    const toggleListening = useCallback(() => {
        if (!canListen || wsClient === null) {
            return;
        }
        if (listening) {
            stopListening();
            return;
        }
        void playerRef.current?.resume();
        wsClient.sendLiveInputAudioMonitor(true);
        setListening(true);
    }, [canListen, listening, stopListening, wsClient]);
    return {
        listening: listening && canListen,
        canListen,
        toggleListening,
    };
};
